import { FormData, FormErrors, ValidationResult } from "../hooks/useAuthForm";

export class ValidationService {
  validateEmail(email: string): boolean {
    return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email);
  }

  validatePassword(password: string): boolean {
    return password.length >= 6;
  }

  validateForm(formData: FormData): ValidationResult {
    const errors: FormErrors = {};
    let isValid = true;

    // Email validation
    if (!formData.email) {
      errors.email = "Email is required";
      isValid = false;
    } else if (!this.validateEmail(formData.email)) {
      errors.email = "Invalid email address";
      isValid = false;
    }

    // Password validation
    if (!formData.password) {
      errors.password = "Password is required";
      isValid = false;
    } else if (!this.validatePassword(formData.password)) {
      errors.password = "Password must be at least 6 characters";
      isValid = false;
    }

    return { isValid, errors };
  }
}

// Export instance for backward compatibility
export const authValidationService = new ValidationService();
